import { unstable_useForkRef as useForkRef } from '@mui/utils';
import { type ComponentPropsWithoutRef, forwardRef, useRef } from 'react';
import Draggable from 'react-draggable';
import { useScreenDimensions } from 'src/utils/system';
import { MODAL_DRAG_HANDLE_CLASS } from './modal-container.utils';

export const ModalContainerPaper = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  (props, ref) => {
    const nodeRef = useRef<HTMLDivElement>(null);
    const combinedRef = useForkRef(ref, nodeRef);
    const { isMobile } = useScreenDimensions();

    return (
      <Draggable
        nodeRef={nodeRef}
        handle={`.${MODAL_DRAG_HANDLE_CLASS}`}
        cancel="button"
        bounds="parent"
        disabled={isMobile}
      >
        <div {...props} ref={combinedRef} />
      </Draggable>
    );
  },
);

ModalContainerPaper.displayName = 'ModalContainerPaper';
